import { useCallback } from 'react';
import { usePersistItem } from '~/components/Store';

export type UseFlagOptions = {
  name: string;
  value?: any;
  disabled?: boolean;
};

export const useFlag = ({ name, value = true, disabled }: UseFlagOptions) => {
  const item = usePersistItem(name);
  const { setValue: setItemValue } = item;
  const hidden = disabled || item.value === value;
  const setValue = useCallback(
    (v = value) => {
      setItemValue(v);
    },
    [setItemValue, value]
  );
  const hide = useCallback(() => {
    if (!hidden) {
      setValue();
    }
  }, [hidden, setValue]);

  return {
    ...item,
    setValue,
    hidden,
    hide,
  };
};
